export default {
  SET_MINIMIZE_CALL_TO_ACTION: 'SET_MINIMIZE_CALL_TO_ACTION'
};
